var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"tiny-dot-matrix",attrs:{"tag":"div","css":false},on:{"enter":_vm.showDot,"leave":_vm.hideDot}},_vm._l(((_vm.numOfCols * _vm.numOfRow)),function(n){return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.matrixPattern[n - 1] === 1),expression:"matrixPattern[n - 1] === 1"}],key:n,staticClass:"dot",style:(_vm.getDotStyles(n))})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2479ffe4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dotMatrix.vue
// module id = 461
// module chunks = 1